import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from './../components/AuthContext';
import { useAuth } from '../components/AuthContext';
import { useUserId } from '../components/UserIdHook';
import './FeedbackPage.scss';

const FeedbackPage: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [feedbackType, setFeedbackType] = useState<string>('feature');
  const [description, setDescription] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [showThankYou, setShowThankYou] = useState<boolean>(false);
  const [editingId, setEmail] = useState<string | null>(null);
  const [isLoading, setUserId] = useState(true);
  const [userid, setUserid] = useState<string | null>(null); 
  
  const user_id = useUserId(user) ?? '';

  useEffect(() => {
    if (user_id ) {
        setUserid(user_id);
      }

  }, [user_id]);
  

  const feedbackTypes = [
    { id: 'feature', label: 'New Feature', icon: '✨' },
    { id: 'bug', label: 'Bug Report', icon: '🐞' },
    { id: 'improvement', label: 'Improvement', icon: '📈' },
    { id: 'other', label: 'Other', icon: '💡' },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const payload = {
        entity: 'FeedbackTable',
        action: 'upsert',
        pk_column: 'feedback_id',
        pk_value: new Date().toISOString(),
        columns: {
          feedback_type: feedbackType,
          feedback_description: description,
          user_id: user_id || 'anonymous',
          user_email: user_id || 'anonymous',
          feedback_timestamp: new Date().toISOString(),
        },
      };

      await axios.post('https://dw1271o3wa.execute-api.us-east-1.amazonaws.com/v1/tablefields', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      console.log(JSON.stringify(payload));

      setShowThankYou(true);
      setDescription('');
    } catch (error) {
      console.error('Error submitting feedback:', error);
      alert('There was an error submitting your feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="feedback-page">
      <h1>We'd love to hear from you!</h1>
      {showThankYou && (
        <div className="thank-you-message">
          Thank you for your feedback! We truly appreciate your input.
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="feedback-types">
          {feedbackTypes.map((type) => (
            <button
              key={type.id}
              type="button"
              className={`feedback-type ${feedbackType === type.id ? 'selected' : ''}`}
              onClick={() => setFeedbackType(type.id)}
            >
              <span className="icon">{type.icon}</span>
              {type.label}
            </button>
          ))}
        </div>
        <textarea
          placeholder="Tell us more... (required)"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={4}
          required
        />
        <button type="submit" className="submit-button" disabled={!description || isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
        </button>
      </form>
    </div>
  );
};

export default FeedbackPage;